
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { myCourseMenu } from '@xt/client/dataSource/my-v2/index'
import AllCourse from '../../components/AllCourse.vue'
import OfflineCourse from '../../components/OfflineCourse.vue'
import ProductCourse from '../../components/ProductCourse.vue'
import TeachCourse from '../../components/TeachCourse.vue'

@Component({
  components: {
    AllCourse,
    OfflineCourse,
    ProductCourse,
    TeachCourse
  },
  asyncData(ctx) {
    const { active } = ctx.query
    const menu = myCourseMenu.find(item => item.value === active)

    if (!active || !menu)
      return {
        active: myCourseMenu[0].value,
        currentComponentName: myCourseMenu[0].component
      }

    const { value, component } = menu

    return {
      active: value,
      currentComponentName: component
    }
  }
})
export default class extends Vue {
  active: string
  currentComponentName: string

  get myCourseMenu() {
    return myCourseMenu
  }

  hanldeChangeMenu(key: string): void {
    if (this.active === key) return

    this.active = key

    this.currentComponentName = this.myCourseMenu.find(item => item.value === key)!.component

    this.$router.push({
      path: '/myv2/course',
      query: !key
        ? {}
        : {
            active: key
          }
    })
    document.documentElement.scrollTo({ top: 0 })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
